// similar solution is here: https://blog.devgenius.io/ant-design-component-customization-and-bundle-optimization-a1fa3253a175

// we need manually copy all variables here from LESS
import { AntdTheme } from '../typing/AntdTheme'

const colors = {
  // Dust Red / red color
  red1: '#FFEFEF',
  red2: '#FFCECF',
  red3: '#FF9C9F',
  red4: '#FF7B7F',
  red5: '#FF5A5F',
  red6: '#E65156',
  red7: '#B33F43',
  red8: '#802D30',
  red9: '#4C1B1C',
  red10: '#190909',
  // orange color (+ Vivaldis Orange from old theme)
  orange1: '#FFF6E8',
  orange2: '#FEE4BB',
  orange3: '#FDDBA4',
  orange4: '#FDC876',
  orange5: '#FCB649',
  orange6: '#FBA41B',
  orange7: '#C98316',
  orange8: '#7E520E',
  orange9: '#4B3108',
  orange10: '#322105',
  // volcano
  volcano1: '#FFFAEE',
  volcano2: '#FFF4DD',
  volcano3: '#FFE4AB',
  volcano4: '#FFD989',
  volcano5: '#FFCE68',
  volcano6: '#FFC857',
  volcano7: '#CCA046',
  volcano8: '#997834',
  volcano9: '#4C3A20',
  volcano10: '#332811',
  // Gray color
  gray1: '#FFFFFF',
  gray2: '#FAFAFA',
  gray3: '#F5F5F8',
  gray4: '#E7E9EC',
  gray5: '#D7DBE0',
  gray6: '#C1CBD5',
  gray7: '#9DA5AD',
  gray8: '#575C60',
  gray9: '#34373A',
  gray10: '#111213',
  // Vivaldis Primary / green color
  VivaldisPrimary1: '#FFFBE6',
  VivaldisPrimary2: '#FFEDA3',
  VivaldisPrimary3: '#FFE07A',
  VivaldisPrimary4: '#FFD152',
  VivaldisPrimary5: '#FFBF29',
  VivaldisPrimary6: '#F7A500',
  VivaldisPrimary7: '#C17B00',
  VivaldisPrimary8: '#8E5B00',
  VivaldisPrimary9: '#754303',
  VivaldisPrimary10: '#502E03',
  // Vivaldis Yellow / yellow color
  VivaldisSecondary1: '#FFFAEE',
  VivaldisSecondary2: '#FFF4DD',
  VivaldisSecondary3: '#FFE4AB',
  VivaldisSecondary4: '#FFD989',
  VivaldisSecondary5: '#FFCE68',
  VivaldisSecondary6: '#FFC857',
  VivaldisSecondary7: '#CCA046',
  VivaldisSecondary8: '#997834',
  VivaldisSecondary9: '#4C3A20',
  VivaldisSecondary10: '#332811',
  // BrickJobs Primary (yellow color)
  BrickJobsPrimary1: '#FFFAF0',
  BrickJobsPrimary2: '#FDF3E4',
  BrickJobsPrimary3: '#FAECD9',
  BrickJobsPrimary4: '#F8E5CF',
  BrickJobsPrimary5: '#F5DEC2',
  BrickJobsPrimary6: '#DBBD96',
  BrickJobsPrimary7: '#BF9973',
  BrickJobsPrimary8: '#915E03',
  BrickJobsPrimary9: '#794605',
  BrickJobsPrimary10: '#502E03',
  // BrickJobs Yellow (red color)
  BrickJobsSecondary1: '#FDF4F4',
  BrickJobsSecondary2: '#F3D0D2',
  BrickJobsSecondary3: '#E6A3AA',
  BrickJobsSecondary4: '#D47582',
  BrickJobsSecondary5: '#B63047',
  BrickJobsSecondary6: '#900101',
  BrickJobsSecondary7: '#80001F',
  BrickJobsSecondary8: '#620218',
  BrickJobsSecondary9: '#3C0210',
  BrickJobsSecondary10: '#28000A',
  // Status Green / green color
  StatusGreen_green1: '#F5FFFA',
  StatusGreen_green2: '#CEF3DF',
  StatusGreen_green3: '#84E0AF',
  StatusGreen_green4: '#6BDA9F',
  StatusGreen_green5: '#3ACD7F',
  StatusGreen_green6: '#09C15F',
  StatusGreen_green7: '#079A4C',
  StatusGreen_green8: '#057439',
  StatusGreen_green9: '#044D26',
  StatusGreen_green10: '#022713',
  // Seal Blue color
  blue1: '#F3FBFF',
  blue2: '#CCE9FF',
  blue3: '#B3DEFF',
  blue4: '#99D3FF',
  blue5: '#66BCFF',
  blue6: '#33A6FF',
  blue7: '#0090FF',
  blue8: '#0073CC',
  blue9: '#004880',
  blue10: '#001D33'
}

export const BrickJobsTheme: AntdTheme = {
  // custom properties
  colorBorderHighlight: colors.BrickJobsSecondary6,
  colorTextQuickExtend: colors.BrickJobsPrimary2, // custom color specifically for text color of recommendations contracts
  //
  colorPrimary: colors.BrickJobsPrimary6,
  colorLink: colors.BrickJobsPrimary7,
  colorLinkHover: colors.BrickJobsPrimary5,
  colorLinkActive: colors.BrickJobsPrimary7,
  // alias
  colorTextLightSolid: colors.BrickJobsSecondary6, // In Figma it's `colorTextLightSolidPrimary`
  // components
  Menu: {
    itemSelectedBg: colors.BrickJobsPrimary5,
    itemSelectedColor: colors.BrickJobsSecondary6, // In Figma it's `itemSelectedTextColor`
    subMenuItemSelectedColor: colors.BrickJobsPrimary6
  },
  Radio: {
    buttonColor: colors.BrickJobsPrimary7
  },
  Tooltip: {
    colorTextLightSolid: '#FFFFFF'
  },
  // colors
  white: '#FFFFFF',
  colorBgLayout: '#F4F4F4',
  // base colors
  ...colors,

  // tokens from ANTD
  screenXS: 480,
  screenSM: 576,
  screenMD: 768,
  screenLG: 992,
  screenXL: 1200,
  screenXXL: 1600
}
